import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { DirectivesModule } from 'app/shared/directives/directives.module';
import { objectsManagerRoutes } from './objects-manager.routing';
import { ObjectsManagerComponent } from './objects-manager.component';
import { ObjectsManagerListComponent } from './list/list.component';
import { AddObjectComponent } from './modals/add-object/add-object.component';
import { ObjectsManagerDetailsComponent } from './details/details.component';
import { AddRelationshipToObjectComponent } from './modals/add-relationship-to-object/add-relationship-to-object.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TsPipesModule } from 'tsui';

@NgModule({
  declarations: [
    ObjectsManagerComponent,
    ObjectsManagerListComponent,
    AddObjectComponent,
    ObjectsManagerDetailsComponent,
    AddRelationshipToObjectComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(objectsManagerRoutes),
    ReactiveFormsModule,
    MatMenuModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    DirectivesModule,
    MatTabsModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,
    PipesModule,
    TsPipesModule,
  ],
})
export class ObjectsManagerModule {}
